// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lb-1";
export var messageSideRight = "_lb-2";
export var subscribeToBackInStockBubbleContainer = "_lb-0";